import React, { useState, useEffect } from 'react';
import HeroBanner from '../components/HeroBanner';
import ProcessFlow from '../components/ProcessFlow';
import ServiceCard from '../components/ServiceCard';
import Gallery from '../components/Gallery';
import BeforeAfterGallery from '../components/BeforeAfterGallery';
import SteamDifferentiator from '../components/SteamDifferentiator';
import OfficialPriceTable from '../components/OfficialPriceTable';
import StatsBar from '../components/StatsBar';
import ReviewSlider from '../components/ReviewSlider';
import BrandStory from '../components/BrandStory';
import { SERVICES as FALLBACK_SERVICES } from '../data/services';
import { AWS_CONFIG } from '../config/aws';
import IntroVideo from '../components/IntroVideo';
import YoutubeChannelButton from '../components/YoutubeChannelButton';
import CustomerPhotoPanorama from '../components/CustomerPhotoPanorama';

export default function HomePage() {
  const [services, setServices] = useState(FALLBACK_SERVICES);

  useEffect(() => {
    fetch(`${AWS_CONFIG.apiUrl}/services`)
      .then(r => r.json())
      .then(data => {
        if (data.services?.length > 0) {
          const normalized = data.services.map(s => ({
            ...s,
            id: s.serviceId || s.id,
          }));
          setServices(normalized);
        }
      })
      .catch(() => {}); // fallback to hardcoded
  }, []);

  return (
    <>
      <title>수원 스팀세차 | KOA DETAILING (곡반정)</title>
      <meta name="description" content="수원 곡반정의 프리미엄 스팀 손세차 전문점 'KOA DETAILING'. 외부/내부 스팀 클리닝, 풀 패키지, 시트 클리닝. 화-토 10:00~19:00. 전화·카카오톡 상담." />
      <link rel="canonical" href="https://koa-asia.com/" />

      {/* 01 Hero */}
      <HeroBanner />

      {/* 01.1 고객 사진 파노라마 */}
      <CustomerPhotoPanorama />

      {/* 01.3 Steam USP — 가치 각인 후 가격표 노출 */}
      <SteamDifferentiator />

      {/* 01.5 Price Table — 공식 가격표 펼침 노출 (이탈 방지 + 신뢰).
          id="pricing" + scrollMarginTop은 NavBar '서비스&가격' 메뉴 스크롤 타겟. */}
      <section id="pricing" style={{
        padding: 'clamp(28px, 4vw, 56px) 0',
        background: 'var(--surface-elev)',
        borderBottom: '1px solid var(--border)',
        scrollMarginTop: 64,
      }}>
        <div className="container">
          <h2 className="section-title" style={{ marginBottom: 8 }}>요금표</h2>
          <p className="section-subtitle" style={{ marginBottom: 24 }}>
            대표 결정 공식 가격 · 차종 5단계 × 메뉴 6종
          </p>
          <OfficialPriceTable />
        </div>
      </section>

      {/* 02 YouTube */}
      <section className="section" style={{ background: 'var(--surface)', padding: 'clamp(36px, 6vw, 80px) 0' }}>
        <div className="container" style={{ textAlign: 'center' }}>
          <h2 className="section-title">KOA DETAILING 소개</h2>
          <p className="section-subtitle">
            프리미엄 스팀 손세차의 모든 과정을 영상으로 만나보세요
          </p>
          <IntroVideo />
          <YoutubeChannelButton />
        </div>
      </section>

      {/* 03 Process */}
      <ProcessFlow />

      {/* 04 Services */}
      <section className="section">
        <div className="container">
          <h2 className="section-title">서비스</h2>
          <p className="section-subtitle">
            전문 스팀 장비와 친환경 약품으로 세심하게 관리합니다
          </p>
          <div style={{
            maxWidth: 560,
            margin: '-32px auto 36px',
            textAlign: 'center',
            padding: '10px 16px',
            background: 'rgba(74, 159, 255, 0.08)',
            borderRadius: 8,
            fontSize: '0.95rem',
            lineHeight: 1.5,
            position: 'relative',
          }}>
            <strong style={{ color: 'var(--primary)' }}>엔진룸, 트렁크 세정 기본 포함</strong>
            {/* 자체 줄로 내려 한국어 단어 단위(keep-all)로만 줄바꿈 — 좁은 화면에서도 안 잘림 */}
            <span style={{
              display: 'block', marginTop: 2,
              color: 'var(--text-muted)', fontSize: '0.85rem',
              wordBreak: 'keep-all',
            }}>(차량 상태에 따라 추가금 발생할 수 있습니다)</span>
          </div>
          <div className="service-grid" style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
            gap: 24,
          }}>
            {services.map(s => (
              <ServiceCard key={s.id || s.serviceId} service={s} />
            ))}
          </div>
        </div>
      </section>

      {/* 05 Before & After */}
      <BeforeAfterGallery />

      {/* 06 Gallery */}
      <Gallery />

      {/* 06 Stats */}
      <StatsBar />

      {/* 07 Reviews */}
      <section className="section" style={{ background: 'var(--surface)' }}>
        <div className="container">
          <h2 className="section-title">고객 후기</h2>
          <p className="section-subtitle">
            KOA DETAILING를 경험한 고객님들의 이야기
          </p>
          <ReviewSlider />
        </div>
      </section>

      {/* 08 Brand Story */}
      <BrandStory />
    </>
  );
}
